import { Analytics } from "utils/analytics"
import { BottomFixed } from "components"
import { Button } from "ui-kit/components-branded/index"
import { Psychologist } from "utils/interfaces"
import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"
import { ServicesGroup } from "utils/helpers/ServicesGroup"

interface Props {
    regimen: string
    serviceGroup: ServicesGroup | undefined
    psy: Psychologist
    nextPage: () => void
    initiator: INITIATOR

    onClickButton?: () => void
}

export function NextPageButton({
    regimen,
    serviceGroup,
    psy,
    nextPage,
    initiator,
    onClickButton,
}: Props) {
    function handleClickButton() {
        if (!serviceGroup) return

        Analytics.psychologist_service_selected({
            service_type: serviceGroup.name,
            psy,
        })
        if (initiator === INITIATOR.CLIENT) {
            onClickButton?.()
        } else {
            nextPage()
        }
    }

    return regimen === "desktop" ? (
        <Button
            color="primary"
            isFullwidth
            onClick={handleClickButton}
            disabled={!serviceGroup?.availableStatusWithCompany.ok}
        >
            Дальше
        </Button>
    ) : (
        <div className="next-page-button-mobile-container">
            <BottomFixed className="next-page-button-mobile">
                <Button
                    color="primary"
                    isFullwidth
                    onClick={handleClickButton}
                    disabled={!serviceGroup?.availableStatusWithCompany.ok}
                >
                    Дальше
                </Button>
            </BottomFixed>
        </div>
    )
}
